import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useVideoDetail, useVideoEmoji } from '../../../commons/customHooks/Video';
import VideoPlayerComponent from '../components/detail/videoPlayer';
import * as action from '../redux/actions/';

const VideoPlayerPageContainer = () => {
  const [videoEmoji, isProcessingEmoji] = useVideoEmoji(null);

  const paramUrl = useParams();

  const [params, setParams] = useState({
    id: paramUrl.id
  })
  const [videoDetail, isProcessing] = useVideoDetail(params);
  console.log(videoDetail,isProcessing, 'VideoRecommentPlayerPageContainer ');
  return <VideoPlayerComponent 
    videoDetail={videoDetail} 
    videoEmoji={videoEmoji}
    isProcessing={isProcessing}
    updateVideo={action.updateVideoRequest}
    deleteVideo={action.deleteVideoRequest}
    />;
};

export default VideoPlayerPageContainer;
